import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import { shallowEqual, useSelector } from 'react-redux';

const PartnerOfferingsFilterSelect = ({filterPartner, setFilterPartner}) => {
    const getPOs = (state) => state.conversions.conversionPartnerOfferings;
    const conversionPartnerOfferings = useSelector(getPOs, areOfferingsEqual);
    return (
        <div>
            <select
                id="partner-select"
                className="rounded p-1"
                placeholder="Partner Offering"
                value={filterPartner}
                onChange={(e) => setFilterPartner(e.target.value)}>
                <option value="">All Offerings</option>
                <option />
                {conversionPartnerOfferings?.map((o, x) => (
                    <option key={x} value={o.id}>
                        {o.partnerOffering}
                    </option>
                ))}
            </select>
            {filterPartner && (
                <span>
                    &nbsp; &nbsp;
                    <FontAwesomeIcon icon={faFilter} />
                </span>
            )}
        </div>
    );
};

const areOfferingsEqual = (newOfferingsList, oldOfferingsList) => {
    if(oldOfferingsList.length !== newOfferingsList.length) return false;
    const offeringEqualityCheck = (oldOffering) => {
        const compareOffering = (newOffering) => {
            return shallowEqual(newOffering, oldOffering);
        };
        return newOfferingsList.some(compareOffering);
    };
    const compareOffering = !!oldOfferingsList.length && oldOfferingsList.every(offeringEqualityCheck);
    const isSameOfferingList = !!newOfferingsList.length && compareOffering;
    return isSameOfferingList;
};

export default PartnerOfferingsFilterSelect;
